import { Injectable } from "@angular/core";
import { dateUtil } from "src/app/support/date-util";

export enum NotifyNewContentNames {
  EDIT_ADDRESS_GOOGLE_SUGGESTION = "edit-address-google-suggestion",
  SURVEYS_MASTER = "surveys-master",
  PAGE_DETAIL_NEW_ACTIONS_TOOLBAR = "page-detail-new-actions-toolbar"
}

@Injectable({ providedIn: "root" })
export class NotifyNewContentService {
  private map: Record<NotifyNewContentNames, { expiresAt: string }> = {
    [NotifyNewContentNames.EDIT_ADDRESS_GOOGLE_SUGGESTION]: {
      expiresAt: dateUtil("2024-07-05").toISOString()
    },
    [NotifyNewContentNames.SURVEYS_MASTER]: {
      expiresAt: dateUtil("2024-07-20").toISOString()
    },
    [NotifyNewContentNames.PAGE_DETAIL_NEW_ACTIONS_TOOLBAR]: {
      expiresAt: dateUtil("2024-09-20").toISOString()
    }
  };

  isExpired(name: NotifyNewContentNames): boolean {
    return dateUtil(this.map[name].expiresAt).isBefore(dateUtil());
  }
}
